<template>
  <div v-if="storeGlobal.valores != {}" class="banner-top-page__container">
    <div
      v-if="isRoigarenaDomain && isHomePage"
      class="roigarena-banner"
      :style="{ 'background-image': 'url(' + bannerRoigarenaImage + ')' }">
      <div class="roigarena-overlay" />
      <div class="roigarena-content">
        <div class="roigarena-text-content">
          <span class="roigarena-title fs-80 bold h3-m medium-m">
            {{ $t('home.banner.roigarena.title') }}
          </span>
          <p class="roigarena-description h6 small-m">
            {{ $t('home.banner.roigarena.description') }}
          </p>
        </div>
        <button class="roigarena-button" @click="scrollToNextSection">
          {{ $t('home.banner.roigarena.button') }}
        </button>
      </div>
      <div class="container padding-cabecera-mobile">
        <slot />
      </div>
    </div>
    <div
      v-if="isViajesviloriaDomain && isHomePage"
      class="viajesviloria-banner"
      :style="{ 'background-image': 'url(' + bannerViajesviloriaImage + ')' }">
      <div class="viajesviloria-overlay" />
      <div class="viajesviloria-content">
        <div class="viajesviloria-text-content">
          <span class="viajesviloria-title h1 bold h3-m medium-m">
            {{ $t('home.banner.viajesviloria.title') }}
          </span>
          <p class="viajesviloria-description h6 small-m">
            {{ $t('home.banner.viajesviloria.description') }}
          </p>
        </div>
        <button class="btn btn-primary" @click="scrollToNextSection">
          {{ $t('home.banner.viajesviloria.button') }}
        </button>
      </div>
      <div class="container padding-cabecera-mobile">
        <slot />
      </div>
    </div>
    <div
      v-if="isIzenitravelDomain && isHomePage"
      class="izenitravel-banner"
      :style="{ 'background-image': 'url(' + bannerIzenitravelImage + ')' }">
      <div class="izenitravel-overlay" />
      <div class="izenitravel-content">
        <div class="izenitravel-text-content">
          <span class="izenitravel-title h1 bold h3-m medium-m">
            {{ $t('home.banner.izenitravel.title') }}
          </span>
          <p class="izenitravel-description h6 small-m">
            {{ $t('home.banner.izenitravel.description') }}
          </p>
        </div>
        <button class="btn btn-primary" @click="scrollToNextSection">
          {{ $t('home.banner.izenitravel.button') }}
        </button>
      </div>
      <div class="container padding-cabecera-mobile">
        <slot />
      </div>
    </div>
    <div
      v-if="isMadcupDomain && isHomePage"
      class="madcup-banner"
      :style="{ 'background-image': 'url(' + bannerMadcupImage + ')' }">
      <div class="madcup-overlay" />
      <div class="madcup-content">
        <div class="madcup-text-content">
          <span class="madcup-title fs-80 bold h3-m medium-m">
            {{ $t('home.banner.madcup.title') }}
          </span>
          <p class="madcup-description h6 small-m">
            {{ $t('home.banner.madcup.description') }}
          </p>
        </div>
        <button class="madcup-button" @click="scrollToNextSection">
          {{ $t('home.banner.madcup.button') }}
        </button>
      </div>
      <div class="container padding-cabecera-mobile">
        <slot />
      </div>
    </div>
    <div
      v-if="isWelcomeSailingDomain && isHomePage"
      class="welcomesailing-banner"
      :style="{ 'background-image': 'url(' + bannerWelcomeSailingImage + ')' }">
      <div class="welcomesailing-overlay" />
      <div class="welcomesailing-content">
        <div class="welcomesailing-text-content">
          <span class="welcomesailing-title fs-80 bold h3-m medium-m">
            {{ $t('home.banner.welcomesailing.title') }}
          </span>
          <p class="welcomesailing-description h6 small-m">
            {{ $t('home.banner.welcomesailing.description') }}
          </p>
        </div>
        <button class="welcomesailing-button" @click="scrollToNextSection">
          {{ $t('home.banner.welcomesailing.button') }}
        </button>
      </div>
      <div class="container padding-cabecera-mobile">
        <slot />
      </div>
    </div>
    <div
      v-if="isRealmadridDomain && isHomePage"
      class="realmadrid-banner"
      :style="{ 'background-image': 'url(' + bannerRealmadridImage + ')' }">
      <div class="realmadrid-overlay" />
      <div class="realmadrid-content">
        <div class="realmadrid-text-content">
          <span class="realmadrid-title h1 bold h3-m medium-m">
            {{ $t('home.banner.realmadrid.title') }}
          </span>
          <p class="realmadrid-description h6 small-m">
            {{ $t('home.banner.realmadrid.description') }}
          </p>
        </div>
        <button class="btn btn-primary" @click="scrollToNextSection">
          {{ $t('home.banner.realmadrid.button') }}
        </button>
      </div>
      <div class="container padding-cabecera-mobile">
        <slot />
      </div>
    </div>
    <div
      v-if="isHyroxDomain && isHomePage"
      class="hyrox-banner"
      :style="{ 'background-image': 'url(' + bannerHyroxImage + ')' }">
      <div class="hyrox-content">
        <div class="hyrox-text-content">
          <span class="hyrox-title fs-80 bold h3-m medium-m">
            {{ $t('home.banner.hyrox.title') }}
            <span class="hyrox-highlight">{{ $t('home.banner.hyrox.titleHighlight') }}</span>
          </span>
          <p class="hyrox-description h6 small-m">
            {{ $t('home.banner.hyrox.description') }}
          </p>
        </div>
        <button class="hyrox-button" @click="scrollToNextSection">
          {{ $t('home.banner.hyrox.button') }}
        </button>
      </div>
      <div class="container padding-cabecera-mobile">
        <slot />
      </div>
    </div>
    <div
      v-if="isVoltaalsportsDomain && isHomePage"
      class="voltaalsports-banner"
      :style="{ 'background-image': 'url(' + bannerVoltaalsportsImage + ')' }">
      <div class="voltaalsports-content">
        <div class="voltaalsports-text-content">
          <span class="voltaalsports-title fs-70 bold h3-m medium-m">
            {{ $t('home.banner.voltaalsports.title') }}
          </span>
          <p class="voltaalsports-description h6 small-m">
            {{ $t('home.banner.voltaalsports.description') }}
          </p>
        </div>
        <button class="voltaalsports-button" @click="scrollToNextSection">
          {{ $t('home.banner.voltaalsports.button') }}
        </button>
      </div>
      <div class="container padding-cabecera-mobile">
        <slot />
      </div>
    </div>
    <div
      v-if="isMarkethubDomain && isHomePage"
      class="markethub-banner"
      :style="{ 'background-image': 'url(' + bannerMarkethubImage + ')' }">
      <div class="markethub-overlay" />
      <div class="markethub-content">
        <div class="markethub-text-content">
          <span class="markethub-title fs-70 bold h3-m medium-m">
            {{ $t('home.banner.markethub.title') }}
          </span>
          <p class="markethub-description h6 small-m">
            {{ $t('home.banner.markethub.description') }}
          </p>
        </div>
        <button class="markethub-button" @click="goToMarkethubAmericas">
          {{ $t('home.banner.markethub.button') }}
        </button>
      </div>
      <div class="container padding-cabecera-mobile">
        <slot />
      </div>
    </div>
    <div
      v-if="isRmfturkDomain && isHomePage"
      class="rmfturk-banner"
      :style="{ 'background-image': 'url(' + bannerRmfturkImage + ')' }">
      <div class="rmfturk-content">
        <div class="rmfturk-text-content">
          <span class="rmfturk-title fs-70 bold h3-m medium-m">
            {{ $t('home.banner.rmfturk.title') }}
          </span>
          <p class="rmfturk-description h6 small-m">
            {{ $t('home.banner.rmfturk.description') }}
          </p>
        </div>
        <button class="rmfturk-button" @click="scrollToNextSection">
          {{ $t('home.banner.rmfturk.button') }}
        </button>
      </div>
      <div class="container padding-cabecera-mobile">
        <slot />
      </div>
    </div>
    <div
      v-if="isVibessDomain && isHomePage"
      class="vibess-banner"
      :style="{ 'background-image': 'url(' + bannerVibess + ')' }">
      <div class="vibess-content">
        <div class="vibess-text-content">
          <span class="vibess-title fs-80 bold h3-m medium-m">
            {{ $t('home.banner.vibess.title') }}
          </span>
          <p class="vibess-description h6 small-m">
            {{ $t('home.banner.vibess.description') }}
          </p>
        </div>
        <button class="vibess-button" @click="scrollToNextSection">
          {{ $t('home.banner.vibess.button') }}
        </button>
      </div>
      <div class="container padding-cabecera-mobile">
        <slot />
      </div>
    </div>
    <div
      v-if="isSnoandfriendsDomain && isHomePage"
      class="snoandfriends-banner"
      :style="{ 'background-image': 'url(' + bannerSnoandfriends + ')' }">
      <div class="snoandfriends-overlay" />
      <div class="snoandfriends-content">
        <div class="snoandfriends-text-content">
          <span class="snoandfriends-title fs-80 bold h3-m medium-m">
            {{ $t('home.banner.snoandfriends.title') }}
          </span>
          <p class="snoandfriends-description h6 small-m">
            {{ $t('home.banner.snoandfriends.description') }}
          </p>
        </div>
        <button class="snoandfriends-button" @click="scrollToNextSection">
          {{ $t('home.banner.snoandfriends.button') }}
        </button>
      </div>
      <div class="container padding-cabecera-mobile">
        <slot />
      </div>
    </div>
    <div
      v-if="isMeganeveDomain && isHomePage"
      class="meganeve-banner"
      :style="{ 'background-image': 'url(' + bannerMeganeve + ')' }">
      <div class="meganeve-overlay" />
      <div class="meganeve-content">
        <div class="meganeve-text-content">
          <span class="meganeve-title fs-70 bold h3-m medium-m">
            {{ $t('home.banner.meganeve.title') }}
          </span>
          <p class="meganeve-description h6 small-m">
            {{ $t('home.banner.meganeve.description') }}
          </p>
        </div>
        <button class="meganeve-button" @click="scrollToNextSection">
          {{ $t('home.banner.meganeve.button') }}
        </button>
      </div>
      <div class="container padding-cabecera-mobile">
        <slot />
      </div>
    </div>
    <div
      v-if="isPuenteclubDomain && isHomePage"
      class="puenteclub-banner"
      :style="{ 'background-image': 'url(' + bannerPuenteclubImage + ')' }">
      <div class="puenteclub-overlay" />
      <div class="puenteclub-content">
        <div class="puenteclub-text-content">
          <span class="puenteclub-title fs-70 bold h3-m medium-m">
            {{ $t('home.banner.puenteclub.title') }}
          </span>
          <p class="puenteclub-description h6 small-m">
            {{ $t('home.banner.puenteclub.description') }}
          </p>
        </div>
        <button class="puenteclub-button" @click="loginStore.openLoginModal()">
          {{ $t('home.banner.puenteclub.button') }}
        </button>
      </div>
      <div class="container padding-cabecera-mobile">
        <slot />
      </div>
    </div>
    <div
      v-if="isTransviagoDomain && isHomePage"
      class="transviago-banner"
      :style="{ 'background-image': 'url(' + bannerTransviaGoImage + ')' }">
      <div class="transviago-overlay" />
      <div class="transviago-content">
        <div class="transviago-text-content">
          <span class="transviago-title bold">
            {{ $t('home.banner.transviago.title') }}
            {{ $t('home.banner.transviago.title2') }}
          </span>
          <p class="transviago-description h6 small-m">
            {{ $t('home.banner.transviago.description') }}
          </p>
        </div>
        <button class="transviago-button" @click="scrollToNextSection">
          {{ $t('home.banner.transviago.button') }}
        </button>
      </div>
      <div class="container padding-cabecera-mobile">
        <slot />
      </div>
    </div>
    <div
      v-if="
        (!isRoigarenaDomain &&
          !isViajesviloriaDomain &&
          !isIzenitravelDomain &&
          !isMadcupDomain &&
          !isWelcomeSailingDomain &&
          !isRealmadridDomain &&
          !isHyroxDomain &&
          !isVoltaalsportsDomain &&
          !isMarkethubDomain &&
          !isRmfturkDomain &&
          !isVibessDomain &&
          !isSnoandfriendsDomain &&
          !isMeganeveDomain &&
          !isPuenteclubDomain &&
          !isTransviagoDomain) ||
        !isHomePage
      "
      class="img-height"
      :class="backgroundBanner.class"
      :style="backgroundBanner.url ? { 'background-image': 'url(' + backgroundBanner.url + ')' } : {}">
      <div v-if="mostrarBuscador">
        <div v-if="getPageData().title" class="container py-3 pt-3 pt-md-3 text-center">
          <div class="mt-md-3 banner-text">
            {{ $t(getPageData().title) }}
          </div>
        </div>

        <div v-if="checkDomain([DOMAINS.skiandnight])" class="container py-3">
          <BuscadorContainer :is-home="true" />
        </div>

        <div v-if="!checkDomain([DOMAINS.skiandnight])" class="container py-3 pt-5 pt-md-3 flex">
          <div class="mt-4 mb-5 d-flex justify-content-center gap-3 flex-md-row">
            <MyGocuButton
              v-if="!checkDomain([DOMAINS.pokerRed, DOMAINS.euchis2026])"
              :label="$t(getPageData().textBtnCatalogo)"
              @click="goToViajesGrupoCatalogo" />
            <button
              v-if="agenciaStore.buscadorEnabled && getPageData().textBtn"
              class="btn btn-primary small"
              @click="goToBuscador">
              {{ $t(getPageData().textBtn) }}
            </button>
          </div>
        </div>
      </div>

      <div class="container padding-cabecera-mobile">
        <slot />
      </div>
    </div>
  </div>
</template>

<script setup>
  import { useRouter } from 'vue-router';
  import { appGlobalStore } from '@/store_pinia/app';
  import { agenciaStoreModule } from '@/store_pinia/agencia';
  import { computed, ref, onMounted } from 'vue';
  import { useRoute } from 'vue-router';
  import { Buscador, ViajesGrupoCatalogo } from '@/router/RouterNames';
  import { checkDomain, getPageData, DOMAINS } from '@/helpers/domainUtils';
  import { useLoginStore } from '@/store_pinia/login';
  import BuscadorContainer from '@/components/buscadores/BuscadorContainer.vue';
  import MyGocuButton from '@/components/common/buttons/MyGocuButton.vue';
  import bannerRoigarenaImage from '@/assets/home/banner-roigarena-1.png';
  import bannerViajesviloriaImage from '@/assets/home/home-viajesviloria.webp';
  import bannerIzenitravelImage from '@/assets/home/izenitravel-home.webp';
  import bannerMadcupImage from '@/assets/home/madcup1.png';
  import bannerWelcomeSailingImage from '@/assets/home/hometransvia-sport.webp';
  import bannerRealmadridImage from '@/assets/home/realMadrid.png';
  import bannerHyroxImage from '@/assets/home/banner-hyrox.jpg';
  import bannerVoltaalsportsImage from '@/assets/home/voltaalsports-banner.jpg';
  import bannerVibess from '@/assets/home/vibess.jpg';
  import bannerSnoandfriends from '@/assets/home/banner-snoandfriends.png';
  import bannerMeganeve from '@/assets/home/banner-meganeve.png';
  import bannerPuenteclubImage from '@/assets/home/banner-puenteclub.webp';
  import bannerMarkethubImage from '@/assets/home/markethub.webp';
  import bannerRmfturkImage from '@/assets/home/rmfturkiye.jpg';
  import bannerTransviaGoImage from '@/assets/home/banner-transviago.png';

  const router = useRouter();

  const props = defineProps({
    viajesGrupoCatalogo: Boolean,
    mostrarBuscador: {
      type: Boolean,
      default: true,
    },
  });

  const isMobile = ref(window.innerWidth <= 992);
  const storeGlobal = appGlobalStore();
  const route = useRoute();
  const isHomePage = computed(() => route.name === 'home');
  const agenciaStore = agenciaStoreModule();
  const loginStore = useLoginStore();

  const isRoigarenaDomain = computed(() => checkDomain([DOMAINS.roigarena]));
  const isViajesviloriaDomain = computed(() => checkDomain([DOMAINS.viajesviloria]));
  const isIzenitravelDomain = computed(() => checkDomain([DOMAINS.izenitravel]));
  const isMadcupDomain = computed(() => checkDomain([DOMAINS.madcup]));
  const isWelcomeSailingDomain = computed(() => checkDomain([DOMAINS.welcomesailing]));
  const isRealmadridDomain = computed(() => checkDomain([DOMAINS.realmadrid]));
  const isHyroxDomain = computed(() => checkDomain([DOMAINS.hyrox]));
  const isVoltaalsportsDomain = computed(() => checkDomain([DOMAINS.voltaalsports]));
  const isVibessDomain = computed(() => checkDomain([DOMAINS.vibess]));
  const isSnoandfriendsDomain = computed(() => checkDomain([DOMAINS.snoandfriends]));
  const isMeganeveDomain = computed(() => checkDomain([DOMAINS.meganeve]));
  const isPuenteclubDomain = computed(() => checkDomain([DOMAINS.puenteclub]));
  const isMarkethubDomain = computed(() => checkDomain([DOMAINS.markethub]));
  const isRmfturkDomain = computed(() => checkDomain([DOMAINS.rmfturk]));
  const isTransviagoDomain = computed(() => checkDomain([DOMAINS.transviago]));

  const backgroundBanner = computed(() => {
    if (isMobile.value && !isHomePage.value) {
      return {};
    }

    if (isHomePage.value) {
      return {
        class: 'home_background',
        url: storeGlobal.valores.img_home,
      };
    }

    if (props.viajesGrupoCatalogo) {
      return {
        class: 'viajes-grupo-catalogo__background',
        url: storeGlobal.valores.img_catalogo_fondo,
      };
    }

    return {};
  });

  function goToBuscador() {
    router.push({
      name: Buscador,
    });
  }

  function goToViajesGrupoCatalogo() {
    router.push({
      name: ViajesGrupoCatalogo,
    });
  }

  function goToMarkethubAmericas() {
    window.location.href = 'https://markethub-hbx.mygocu.com/agrupaciones/markethub-americas?codigo=HBX';
  }

  function scrollToNextSection() {
    const bannerContainer = document.querySelector('.banner-top-page__container');
    if (!bannerContainer) {
      console.warn('Banner container not found');
      return;
    }

    const parentElement = bannerContainer.parentElement;
    if (!parentElement) {
      console.warn('Parent element not found');
      return;
    }

    const nextSibling = parentElement.nextElementSibling;
    if (nextSibling) {
      nextSibling.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      const agrupacionesContainer = document.querySelector('.agrupaciones-container');
      if (agrupacionesContainer) {
        agrupacionesContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        console.warn('Next section not found');
      }
    }
  }

  onMounted(() => {
    window.addEventListener('resize', () => {
      isMobile.value = window.innerWidth <= 992;
    });
  });
</script>

<style lang="scss" scoped>
  .banner-top-page__container {
    .home_background {
      padding-top: 12rem;
      padding-bottom: 3rem;
      background-position: center;
      background-size: cover;
      background-repeat: no-repeat;
      @media only screen and (max-width: 990px) {
        padding-top: 6rem;
      }
    }

    .viajes-grupo-catalogo__background {
      margin-top: 100px !important;
      height: 350px !important;
      padding-top: 2rem;
      padding-bottom: 4rem;
      background-position: center;
      background-size: cover;
      background-repeat: no-repeat;
      @media only screen and (max-width: 990px) {
        padding-top: 2rem;
      }
    }
  }

  .roigarena-banner {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
    height: 740px;
    padding: 370px 80px 80px 0px;
    justify-content: center;
    align-items: center;
    align-self: stretch;
    background-position: 50% 50%;
    background-size: cover;
    background-repeat: no-repeat;

    @media only screen and (max-width: 768px) {
      padding: 150px 20px 40px 20px;
      height: 578px;
    }
  }

  .roigarena-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    height: 740px;
    padding: 370px 80px 80px 0px;
    justify-content: center;
    align-items: center;
    align-self: stretch;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0.3) 50%, transparent 100%);
    pointer-events: none;
    @media only screen and (max-width: 768px) {
      height: 578px;
    }
  }

  .roigarena-content {
    position: relative;
    z-index: 2;
    display: flex;
    flex-direction: column;
    gap: 50px;
    width: 100%;
    max-width: 1200px;
    align-items: flex-start;
    justify-content: center;
    flex: 0 0 auto;
    min-width: 0;
    min-height: 0;

    @media only screen and (max-width: 768px) {
      gap: 25px;
      padding: 220px 0 0 0;
    }
  }

  .roigarena-text-content {
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
  }

  .roigarena-title {
    color: var(--Blanco, #fff);
    margin: 0;
    text-align: left;
    width: 100%;
  }

  .roigarena-description {
    color: var(--Blanco, #fff);
    margin: 0;
    white-space: pre-wrap;
    text-align: left;
    width: 100%;

    @media only screen and (max-width: 768px) {
      font-size: 14px;
      line-height: 1.5;
    }
  }

  .roigarena-button {
    display: flex;
    height: 40px;
    padding: 10px 24px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 20px;
    background: #df5312;
    color: white;
    font-size: 16px;
    font-weight: 500;
    line-height: 1;
    border: none;
    cursor: pointer;
    transition: background-color 0.3s ease, transform 0.2s ease;
    align-self: flex-start;
    box-shadow: 0px 2px 4px rgba(33, 36, 68, 0.2);

    &:hover {
      background-color: #c4490f;
      transform: translateY(-2px);
      box-shadow: 0px 4px 8px rgba(33, 36, 68, 0.3);
    }

    &:active {
      transform: translateY(0);
    }

    @media only screen and (max-width: 768px) {
      font-size: 14px;
      padding: 8px 20px;
      height: 36px;
    }
  }

  .viajesviloria-banner {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
    height: 740px;
    padding: 370px 80px 80px 0px;
    justify-content: center;
    align-items: center;
    align-self: stretch;
    background-position: 50% 50%;
    background-size: cover;
    background-repeat: no-repeat;

    @media only screen and (max-width: 768px) {
      padding: 150px 20px 40px 20px;
      height: 578px;
      background-position: right center;
    }
  }

  .viajesviloria-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    height: 740px;
    padding: 370px 80px 80px 0px;
    justify-content: center;
    align-items: center;
    align-self: stretch;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0.3) 50%, transparent 100%);
    pointer-events: none;
    @media only screen and (max-width: 768px) {
      height: 578px;
    }
  }

  .viajesviloria-content {
    position: relative;
    z-index: 2;
    display: flex;
    flex-direction: column;
    gap: 50px;
    width: 100%;
    max-width: 1200px;
    align-items: flex-start;
    justify-content: center;
    flex: 0 0 auto;
    min-width: 0;
    min-height: 0;

    @media only screen and (max-width: 768px) {
      gap: 25px;
      padding: 220px 0 100px 0;
    }
  }

  .viajesviloria-text-content {
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
  }

  .viajesviloria-title {
    color: white;
    margin: 0;
    text-align: left;
    width: 100%;
  }

  .viajesviloria-description {
    color: white;
    margin: 0;
    white-space: pre-wrap;
    text-align: left;
    width: 100%;

    @media only screen and (max-width: 768px) {
      font-size: 14px;
      line-height: 1.5;
    }
  }

  .izenitravel-banner {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
    height: 740px;
    padding: 370px 80px 80px 0px;
    justify-content: center;
    align-items: center;
    align-self: stretch;
    background-position: 50% 50%;
    background-size: cover;
    background-repeat: no-repeat;

    @media only screen and (max-width: 768px) {
      padding: 150px 20px 40px 20px;
      height: 578px;
      background-position: right center;
    }
  }

  .izenitravel-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    height: 740px;
    padding: 370px 80px 80px 0px;
    justify-content: center;
    align-items: center;
    align-self: stretch;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0.3) 50%, transparent 100%);
    pointer-events: none;
    @media only screen and (max-width: 768px) {
      height: 578px;
    }
  }

  .izenitravel-content {
    position: relative;
    z-index: 2;
    display: flex;
    flex-direction: column;
    gap: 50px;
    width: 100%;
    max-width: 1200px;
    align-items: flex-start;
    justify-content: center;
    flex: 0 0 auto;
    min-width: 0;
    min-height: 0;

    @media only screen and (max-width: 768px) {
      gap: 25px;
      padding: 220px 0 100px 0;
    }
  }

  .izenitravel-text-content {
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
  }

  .izenitravel-title {
    color: white;
    margin: 0;
    text-align: left;
    width: 100%;
  }

  .izenitravel-description {
    color: white;
    margin: 0;
    white-space: pre-wrap;
    text-align: left;
    width: 100%;

    @media only screen and (max-width: 768px) {
      font-size: 14px;
      line-height: 1.5;
    }
  }

  .madcup-banner {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
    height: 740px;
    padding: 370px 80px 80px 0px;
    justify-content: center;
    align-items: center;
    align-self: stretch;
    background-position: 50% 50%;
    background-size: cover;
    background-repeat: no-repeat;
    @media only screen and (max-width: 768px) {
      padding: 150px 20px 40px 20px;
      height: 578px;
    }
  }

  .madcup-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    height: 740px;
    padding: 370px 80px 80px 0px;
    justify-content: center;
    align-items: center;
    align-self: stretch;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0.3) 50%, transparent 100%);
    pointer-events: none;
    @media only screen and (max-width: 768px) {
      height: 578px;
    }
  }

  .madcup-content {
    position: relative;
    z-index: 2;
    display: flex;
    flex-direction: column;
    gap: 50px;
    width: 100%;
    max-width: 1200px;
    align-items: flex-start;
    justify-content: center;
    flex: 0 0 auto;
    min-width: 0;
    min-height: 0;
    @media only screen and (max-width: 768px) {
      gap: 25px;
      padding: 220px 0 0 0;
    }
  }

  .madcup-text-content {
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
  }

  .madcup-title {
    color: var(--Blanco, #fff);
    margin: 0;
    text-align: left;
    width: 100%;
  }

  .madcup-description {
    color: var(--Blanco, #fff);
    margin: 0;
    white-space: pre-wrap;
    text-align: left;
    width: 100%;

    @media only screen and (max-width: 768px) {
      font-size: 14px;
      line-height: 1.5;
    }
  }

  .madcup-button {
    display: flex;
    height: 40px;
    padding: 10px 24px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 20px;
    background: #aa172c;
    color: #ffffff;
    font-size: 16px;
    font-weight: 500;
    line-height: 1;
    border: none;
    cursor: pointer;
    transition: background-color 0.3s ease, transform 0.2s ease;
    align-self: flex-start;
    box-shadow: 0px 2px 4px rgba(33, 36, 68, 0.2);

    &:hover {
      background-color: #c4490f;
      transform: translateY(-2px);
      box-shadow: 0px 4px 8px rgba(33, 36, 68, 0.3);
    }

    &:active {
      transform: translateY(0);
    }

    @media only screen and (max-width: 768px) {
      font-size: 14px;
      padding: 8px 20px;
      height: 36px;
    }
  }

  .welcomesailing-banner {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
    height: 740px;
    padding: 370px 80px 80px 0px;
    justify-content: center;
    align-items: center;
    align-self: stretch;
    background-position: 50% 50%;
    background-size: cover;
    background-repeat: no-repeat;
    @media only screen and (max-width: 768px) {
      padding: 150px 20px 40px 20px;
      height: 578px;
    }
  }

  .welcomesailing-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    height: 740px;
    padding: 370px 80px 80px 0px;
    justify-content: center;
    align-items: center;
    align-self: stretch;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0.3) 50%, transparent 100%);
    pointer-events: none;
    @media only screen and (max-width: 768px) {
      height: 578px;
    }
  }

  .welcomesailing-content {
    position: relative;
    z-index: 2;
    display: flex;
    flex-direction: column;
    gap: 50px;
    width: 100%;
    max-width: 1200px;
    align-items: flex-start;
    justify-content: center;
    flex: 0 0 auto;
    min-width: 0;
    min-height: 0;
    @media only screen and (max-width: 768px) {
      gap: 25px;
      padding: 220px 0 0 0;
    }
  }

  .welcomesailing-text-content {
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
  }

  .welcomesailing-title {
    color: var(--Blanco, #fff);
    margin: 0;
    text-align: left;
    width: 100%;
  }

  .welcomesailing-description {
    color: var(--Blanco, #fff);
    margin: 0;
    white-space: pre-wrap;
    text-align: left;
    width: 100%;

    @media only screen and (max-width: 768px) {
      font-size: 14px;
      line-height: 1.5;
    }
  }

  .welcomesailing-button {
    display: flex;
    height: 40px;
    padding: 10px 24px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 20px;
    background: var(--bs-secondary);
    color: var(--bs-primary);
    font-size: 16px;
    font-weight: 500;
    line-height: 1;
    border: none;
    cursor: pointer;
    transition: background-color 0.3s ease, transform 0.2s ease;
    align-self: flex-start;
    box-shadow: 0px 2px 4px rgba(33, 36, 68, 0.2);

    &:hover {
      background-color: var(--bs-primary);
      color: var(--bs-secondary);
      transform: translateY(-2px);
      box-shadow: 0px 4px 8px rgba(33, 36, 68, 0.3);
    }

    &:active {
      transform: translateY(0);
    }

    @media only screen and (max-width: 768px) {
      font-size: 14px;
      padding: 8px 20px;
      height: 36px;
    }
  }

  .hyrox-banner {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
    height: 740px;
    padding: 370px 80px 80px 0px;
    justify-content: center;
    align-items: center;
    align-self: stretch;
    background-position: 50% 50%;
    background-size: cover;
    background-repeat: no-repeat;

    @media only screen and (max-width: 768px) {
      padding: 150px 20px 40px 20px;
      height: 578px;
    }
  }

  .hyrox-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    height: 740px;
    padding: 370px 80px 80px 0px;
    justify-content: center;
    align-items: center;
    align-self: stretch;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0.3) 50%, transparent 100%);
    pointer-events: none;
    @media only screen and (max-width: 768px) {
      height: 578px;
    }
  }

  .hyrox-content {
    position: relative;
    z-index: 2;
    display: flex;
    flex-direction: column;
    gap: 50px;
    width: 100%;
    max-width: 1200px;
    align-items: flex-start;
    justify-content: center;
    flex: 0 0 auto;
    min-width: 0;
    min-height: 0;

    @media only screen and (max-width: 768px) {
      gap: 25px;
      padding: 220px 0 0 0;
    }
  }

  .hyrox-text-content {
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
  }

  .hyrox-title {
    color: var(--Blanco, #fff);
    margin: 0;
    text-align: left;
    width: 100%;
  }

  .hyrox-highlight {
    color: #f8e002;
  }

  .hyrox-description {
    color: var(--Blanco, #fff);
    margin: 0;
    white-space: pre-wrap;
    text-align: left;
    width: 100%;

    @media only screen and (max-width: 768px) {
      font-size: 14px;
      line-height: 1.5;
    }
  }

  .hyrox-button {
    display: flex;
    height: 40px;
    padding: 10px 24px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 20px;
    background: #f8e002;
    color: #000000;
    font-size: 16px;
    font-weight: 500;
    line-height: 1;
    border: none;
    cursor: pointer;
    transition: background-color 0.3s ease, transform 0.2s ease;
    align-self: flex-start;
    box-shadow: 0px 2px 4px rgba(33, 36, 68, 0.2);

    &:hover {
      background-color: #333333;
      transform: translateY(-2px);
      box-shadow: 0px 4px 8px rgba(33, 36, 68, 0.3);
    }

    &:active {
      transform: translateY(0);
    }

    @media only screen and (max-width: 768px) {
      font-size: 14px;
      padding: 8px 20px;
      height: 36px;
    }
  }

  .voltaalsports-banner {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
    height: 740px;
    padding: 370px 80px 80px 0px;
    justify-content: center;
    align-items: center;
    align-self: stretch;
    background-position: 50% 50%;
    background-size: cover;
    background-repeat: no-repeat;

    &::before {
      content: '';
      position: absolute;
      inset: 0;
      pointer-events: none;
      z-index: 1;
      background: linear-gradient(45deg, rgba(0, 0, 0, 0.85) 0%, rgba(0, 0, 0, 0) 85%);
    }

    @media only screen and (max-width: 768px) {
      padding: 150px 20px 40px 20px;
      height: 578px;
    }
  }

  .voltaalsports-content {
    position: relative;
    z-index: 2;
    display: flex;
    flex-direction: column;
    gap: 50px;
    width: 100%;
    max-width: 1200px;
    align-items: flex-start;
    justify-content: center;
    flex: 0 0 auto;
    min-width: 0;
    min-height: 0;

    @media only screen and (max-width: 768px) {
      gap: 25px;
      padding: 220px 0 0 0;
    }
  }

  .voltaalsports-text-content {
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
  }

  .voltaalsports-title {
    color: var(--Blanco, #fff);
    margin: 0;
    text-align: left;
    width: 100%;
  }

  .voltaalsports-description {
    color: var(--Blanco, #fff);
    margin: 0;
    white-space: pre-wrap;
    text-align: left;
    width: 100%;

    @media only screen and (max-width: 768px) {
      font-size: 14px;
      line-height: 1.5;
    }
  }

  .voltaalsports-button {
    display: flex;
    height: 40px;
    padding: 10px 24px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 20px;
    background: #f8e002;
    color: #000000;
    font-size: 16px;
    font-weight: 500;
    line-height: 1;
    border: none;
    cursor: pointer;
    transition: background-color 0.3s ease, transform 0.2s ease;
    align-self: flex-start;
    box-shadow: 0px 2px 4px rgba(33, 36, 68, 0.2);

    &:hover {
      background-color: #333333;
      color: #ffffff;
      transform: translateY(-2px);
      box-shadow: 0px 4px 8px rgba(33, 36, 68, 0.3);
    }

    &:active {
      transform: translateY(0);
    }

    @media only screen and (max-width: 768px) {
      font-size: 14px;
      padding: 8px 20px;
      height: 36px;
    }
  }

  .markethub-banner {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
    height: 740px;
    padding: 370px 80px 80px 0px;
    justify-content: center;
    align-items: center;
    align-self: stretch;
    background-position: 50% 50%;
    background-size: cover;
    background-repeat: no-repeat;

    @media only screen and (max-width: 768px) {
      padding: 150px 20px 40px 20px;
      height: 578px;
    }
  }

  .markethub-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    height: 740px;
    padding: 370px 80px 80px 0px;
    justify-content: center;
    align-items: center;
    align-self: stretch;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0.5) 50%, transparent 100%);
    pointer-events: none;
    @media only screen and (max-width: 768px) {
      height: 578px;
    }
  }

  .markethub-content {
    position: relative;
    z-index: 2;
    display: flex;
    flex-direction: column;
    gap: 50px;
    width: 100%;
    max-width: 1200px;
    align-items: flex-start;
    justify-content: center;
    flex: 0 0 auto;
    min-width: 0;
    min-height: 0;

    @media only screen and (max-width: 768px) {
      gap: 25px;
      padding: 220px 0 0 0;
    }
  }

  .markethub-text-content {
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
  }

  .markethub-title {
    color: var(--Blanco, #fff);
    margin: 0;
    text-align: left;
    width: 100%;
  }

  .markethub-description {
    color: var(--Blanco, #fff);
    margin: 0;
    white-space: pre-wrap;
    text-align: left;
    width: 100%;

    @media only screen and (max-width: 768px) {
      font-size: 14px;
      line-height: 1.5;
    }
  }

  .markethub-button {
    display: flex;
    height: 40px;
    padding: 10px 24px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 20px;
    background: var(--bs-secondary);
    color: var(--bs-primary);
    font-size: 16px;
    font-weight: 500;
    line-height: 1;
    border: none;
    cursor: pointer;
    transition: background-color 0.3s ease, transform 0.2s ease;
    align-self: flex-start;
    box-shadow: 0px 2px 4px rgba(33, 36, 68, 0.2);

    &:hover {
      background-color: var(--bs-primary);
      color: var(--bs-secondary);
      transform: translateY(-2px);
      box-shadow: 0px 4px 8px rgba(33, 36, 68, 0.3);
    }

    &:active {
      transform: translateY(0);
    }

    @media only screen and (max-width: 768px) {
      font-size: 14px;
      padding: 8px 20px;
      height: 36px;
    }
  }

  .rmfturk-banner {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
    height: 740px;
    padding: 370px 80px 80px 0px;
    justify-content: center;
    align-items: center;
    align-self: stretch;
    background-position: 50% 50%;
    background-size: cover;
    background-repeat: no-repeat;

    &::before {
      content: '';
      position: absolute;
      inset: 0;
      pointer-events: none;
      z-index: 1;
      background: linear-gradient(45deg, rgba(0, 0, 0, 0.85) 0%, rgba(0, 0, 0, 0) 85%);
    }

    @media only screen and (max-width: 768px) {
      padding: 150px 20px 40px 20px;
      height: 578px;
    }
  }

  .rmfturk-content {
    position: relative;
    z-index: 2;
    display: flex;
    flex-direction: column;
    gap: 50px;
    width: 100%;
    max-width: 1200px;
    align-items: flex-start;
    justify-content: center;
    flex: 0 0 auto;
    min-width: 0;
    min-height: 0;

    @media only screen and (max-width: 768px) {
      gap: 25px;
      padding: 220px 0 0 0;
    }
  }

  .rmfturk-text-content {
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
  }

  .rmfturk-title {
    color: var(--Blanco, #fff);
    margin: 0;
    text-align: left;
    width: 100%;
  }

  .rmfturk-description {
    color: var(--Blanco, #fff);
    margin: 0;
    white-space: pre-wrap;
    text-align: left;
    width: 100%;

    @media only screen and (max-width: 768px) {
      font-size: 14px;
      line-height: 1.5;
    }
  }

  .rmfturk-button {
    display: flex;
    height: 40px;
    padding: 10px 24px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 20px;
    background: var(--bs-secondary);
    color: var(--bs-primary);
    font-size: 16px;
    font-weight: 500;
    line-height: 1;
    border: none;
    cursor: pointer;
    transition: background-color 0.3s ease, transform 0.2s ease;
    align-self: flex-start;
    box-shadow: 0px 2px 4px rgba(33, 36, 68, 0.2);

    &:hover {
      background-color: var(--bs-primary);
      color: var(--bs-secondary);
      transform: translateY(-2px);
      box-shadow: 0px 4px 8px rgba(33, 36, 68, 0.3);
    }

    &:active {
      transform: translateY(0);
    }

    @media only screen and (max-width: 768px) {
      font-size: 14px;
      padding: 8px 20px;
      height: 36px;
    }
  }

  .snoandfriends-banner,
  .puenteclub-banner,
  .meganeve-banner,
  .vibess-banner {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
    height: 740px;
    padding: 370px 80px 80px 0px;
    justify-content: center;
    align-items: center;
    align-self: stretch;
    background-position: 50% 50%;
    background-size: cover;
    background-repeat: no-repeat;

    @media only screen and (max-width: 768px) {
      padding: 150px 20px 40px 20px;
      height: 578px;
    }
  }

  .snoandfriends-overlay,
  .puenteclub-overlay,
  .meganeve-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    height: 740px;
    padding: 370px 80px 80px 0px;
    justify-content: center;
    align-items: center;
    align-self: stretch;
    pointer-events: none;
    @media only screen and (max-width: 768px) {
      height: 578px;
    }
  }

  .snoandfriends-content,
  .puenteclub-content,
  .meganeve-content,
  .vibess-content {
    position: relative;
    z-index: 2;
    display: flex;
    flex-direction: column;
    gap: 50px;
    width: 100%;
    max-width: 1200px;
    align-items: flex-start;
    justify-content: center;
    flex: 0 0 auto;
    min-width: 0;
    min-height: 0;

    @media only screen and (max-width: 768px) {
      gap: 25px;
      padding: 220px 0 0 0;
    }
  }

  .snoandfriends-text-content,
  .puenteclub-text-content,
  .meganeve-text-content,
  .vibess-text-content {
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
  }

  .snoandfriends-title,
  .puenteclub-title,
  .vibess-title {
    color: var(--Blanco, #fff);
    margin: 0;
    text-align: left;
    width: 100%;
  }

  .meganeve-title {
    color: var(--Blanco, #000000);
    margin: 0;
    text-align: left;
    width: 100%;
  }

  .snoandfriends-description,
  .puenteclub-description,
  .vibess-description {
    color: var(--Blanco, #fff);
    margin: 0;
    white-space: pre-wrap;
    text-align: left;
    width: 100%;

    @media only screen and (max-width: 768px) {
      font-size: 14px;
      line-height: 1.5;
    }
  }

  .meganeve-description {
    color: var(--Blanco, #000000);
    margin: 0;
    white-space: pre-wrap;
    text-align: left;
    width: 100%;

    @media only screen and (max-width: 768px) {
      font-size: 14px;
      line-height: 1.5;
    }
  }

  .snoandfriends-button,
  .puenteclub-button,
  .meganeve-button,
  .vibess-button {
    display: flex;
    height: 40px;
    padding: 10px 24px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 20px;
    background: var(--bs-secondary);
    color: var(--bs-primary);
    font-size: 16px;
    font-weight: 500;
    line-height: 1;
    border: none;
    cursor: pointer;
    transition: background-color 0.3s ease, transform 0.2s ease;
    align-self: flex-start;
    box-shadow: 0px 2px 4px rgba(33, 36, 68, 0.2);

    &:hover {
      background-color: #1565c0;
      transform: translateY(-2px);
      box-shadow: 0px 4px 8px rgba(33, 36, 68, 0.3);
    }

    &:active {
      transform: translateY(0);
    }

    @media only screen and (max-width: 768px) {
      font-size: 14px;
      padding: 8px 20px;
      height: 36px;
    }
  }

  .transviago-banner {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
    height: 740px;
    padding: 370px 80px 80px 0px;
    justify-content: center;
    align-items: center;
    align-self: stretch;
    background-position: 50% 50%;
    background-size: cover;
    background-repeat: no-repeat;

    @media only screen and (max-width: 768px) {
      padding: 150px 20px 100px 20px;
      height: 578px;
    }
  }

  .transviago-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    height: 740px;
    padding: 370px 80px 80px 0px;
    justify-content: center;
    align-items: center;
    align-self: stretch;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0.3) 50%, transparent 100%);
    pointer-events: none;
    @media only screen and (max-width: 768px) {
      height: 578px;
    }
  }

  .transviago-content {
    position: relative;
    z-index: 2;
    display: flex;
    flex-direction: column;
    gap: 50px;
    width: 100%;
    max-width: 1200px;
    align-items: flex-start;
    justify-content: center;
    flex: 0 0 auto;
    min-width: 0;
    min-height: 0;

    @media only screen and (max-width: 768px) {
      gap: 25px;
      padding: 220px 0 0 0;
    }
  }

  .transviago-text-content {
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
  }

  .transviago-title {
    color: var(--Blanco, #fff);
    font-size: 56px;
    margin: 0;
    text-align: left;
    width: 100%;
    line-height: 1.2;
    @media only screen and (max-width: 768px) {
      font-size: 34px;
      line-height: 1;
    }
  }

  .transviago-description {
    color: var(--Blanco, #fff);
    margin: 0;
    white-space: pre-wrap;
    text-align: left;
    width: 100%;

    @media only screen and (max-width: 768px) {
      font-size: 14px;
      line-height: 1.5;
    }
  }

  .transviago-button {
    display: flex;
    height: 40px;
    padding: 10px 24px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 20px;
    background: #df5312;
    color: white;
    font-size: 16px;
    font-weight: 500;
    line-height: 1;
    border: none;
    cursor: pointer;
    transition: background-color 0.3s ease, transform 0.2s ease;
    align-self: flex-start;
    box-shadow: 0px 2px 4px rgba(33, 36, 68, 0.2);

    &:hover {
      background-color: var(--bs-primary);
      color: var(--bs-secondary);
      transform: translateY(-2px);
      box-shadow: 0px 4px 8px rgba(33, 36, 68, 0.3);
    }

    &:active {
      transform: translateY(0);
    }

    @media only screen and (max-width: 768px) {
      font-size: 14px;
      padding: 8px 20px;
      height: 36px;
    }
  }

  .realmadrid-banner {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
    height: 740px;
    padding: 80px;
    justify-content: center;
    align-items: center;
    align-self: stretch;
    background-position: 50% 50%;
    background-size: cover;
    background-repeat: no-repeat;
    @media only screen and (max-width: 768px) {
      padding: 100px 20px 40px 20px;
      height: 578px;
    }
  }

  .realmadrid-content {
    position: relative;
    z-index: 0;
    display: flex;
    flex-direction: column;
    gap: 30px;
    width: 100%;
    max-width: 1200px;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    min-width: 0;
    min-height: 0;
    margin-top: 40px;
    @media only screen and (max-width: 768px) {
      gap: 20px;
      padding: 0;
    }
  }

  .realmadrid-text-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    width: 100%;
  }

  .realmadrid-title {
    color: var(--Blanco, #fff);
    margin: 0;
    text-align: center;
    width: 100%;

    @media only screen and (max-width: 768px) {
      width: 80%;
    }
  }

  .realmadrid-description {
    color: var(--Blanco, #fff);
    margin-bottom: 15px;
    white-space: pre-wrap;
    text-align: center;
    width: 100%;
    max-width: 1200px;

    @media only screen and (max-width: 768px) {
      font-size: 14px;
      line-height: 1.5;
    }
  }

  .banner-text {
    color: var(--Blanco, #fff);
    text-align: center;
    text-shadow: 0px 0px 1px rgba(33, 36, 68, 0.4), 2px 4px 5px rgba(33, 36, 68, 0.1),
      4px 6px 20px rgba(33, 36, 68, 0.1);
    font-family: 'Montserrat';
    font-size: 65px;
    font-style: italic;
    font-weight: 700;
    line-height: normal;
    letter-spacing: 0.18px;
    text-transform: uppercase;
  }

  .btn-primary {
    background-color: var(--bs-primary);
    border-color: var(--bs-primary);
    border-radius: 50px;
    font-size: 18px;
    padding: 10px 20px;
    color: #fff;
    text-shadow: 0px 0px 1px rgba(var(--bs-primary-rgb), 0.4), 2px 4px 5px rgba(var(--bs-primary-rgb), 0.1);
    box-shadow: 2px 2px 4px rgba(var(--bs-primary-rgb), 0.2);
    transition: background-color 0.3s ease;
    cursor: pointer;
  }

  @media (max-width: 768px) {
    .banner-text {
      color: white;
      text-align: center;
      text-shadow: 0px 0px 1px rgba(var(--bs-primary-rgb), 0.4), 2px 4px 5px rgba(var(--bs-primary-rgb), 0.1),
        4px 6px 20px rgba(var(--bs-primary-rgb), 0.1);
      font-family: 'Montserrat';
      font-size: 45px;
      font-style: italic;
      font-weight: 700;
      line-height: normal;
      letter-spacing: 0.18px;
      text-transform: uppercase;
    }
    .btn-primary {
      height: 40px;
      margin: 0 auto;
      padding: 10px 24px;
      border-radius: var(--bs-border-radius-xxl);
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
</style>
